import { sendRequest } from 'api/sendRequest';
import { OneOnOneAgenda } from 'screens/oneOnOneRabbit/interfaces/OneOnOneAgenda';
import { OneOnOneRequestI } from 'screens/oneOnOneRabbit/interfaces/common';
import { z } from 'zod';

import { endpoints } from 'constants/endpoints';

import { ReorderAgendaI } from '../hooks/dataHooks';
import { OneOnOneAgendaNotesUpdateI, OneOnOneAgendaUpdateI } from '../services';

export const getOneOnOneAgendaApi = ({ masterId, instanceId }: OneOnOneRequestI) => {
  const url = endpoints.oneOnOneRevamped.agenda(masterId);
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      instanceId,
    },
  });
};

type OneOnOneAgendaCreateI = OneOnOneRequestI & z.infer<typeof OneOnOneAgenda>;

export const createOneOnOneAgendaApi = ({ masterId, instanceId, ...rest }: OneOnOneAgendaCreateI) => {
  const url = endpoints.oneOnOneRevamped.agenda(masterId);
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      instanceId,
    },
    body: {
      ...rest,
    },
  });
};

export const updateOneOnOneAgendaApi = ({
  masterId,
  instanceId,
  instanceDataId,
  templateAgendaId,
  ...rest
}: OneOnOneAgendaUpdateI) => {
  const url = endpoints.oneOnOneRevamped.agenda(masterId);
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      instanceId,
      instanceDataId,
      templateAgendaId,
    },
    body: {
      ...rest,
    },
  });
};

export const deleteOneOnOneAgendaApi = ({
  masterId,
  instanceId,
  instanceDataId,
}: OneOnOneRequestI & { instanceDataId: number }) => {
  const url = endpoints.oneOnOneRevamped.agenda(masterId);
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'DELETE',
    credentials: 'include',
    queryParams: {
      instanceId,
      instanceDataId,
    },
  });
};

export const updateOneOnOneAgendaCompletionApi = ({
  masterId,
  instanceId,
  instanceDataId,
  templateAgendaId,
  isCompleted,
}: OneOnOneAgendaUpdateI) => {
  const url = endpoints.oneOnOneRevamped.updateCompletion(masterId);
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      instanceId,
      instanceDataId,
      templateAgendaId,
      isComplete: isCompleted,
    },
  });
};

export const updateOneOnOneAgendaNotesApi = async ({
  masterId,
  instanceId,
  instanceDataId,
  templateAgendaId,
  isPrivate,
  ...rest
}: OneOnOneAgendaNotesUpdateI) => {
  const url = endpoints.oneOnOneRevamped.agendaNotes(masterId);
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      instanceId,
      instanceDataId,
      templateAgendaId,
    },
    body: {
      feedbackText: rest.feedbackText,
      feedbackTextHtml: rest.feedbackTextHtml,
      isPrivate,
    },
  });
};

export const reorderOneOnOneAgenda = ({
  masterId,
  instanceId,
  reorderInstanceDataId = null,
  topInstanceDataId,
}: OneOnOneRequestI & ReorderAgendaI) => {
  const url = endpoints.oneOnOneRevamped.reorderAgenda(masterId);
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      instanceId,
      reorderInstanceDataId,
      topInstanceDataId,
    },
  });
};

export const getOneOnOneBotRecommendationsApi = ({ masterId, instanceId }: OneOnOneRequestI) => {
  const url = endpoints.oneOnOneRevamped.botRecommendations(masterId);
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      instanceId,
    },
  });
};

export const deleteOneOnOneAiRecommendationsApi = ({ masterId, instanceId, aiGeneratedDataId }: OneOnOneRequestI) => {
  const url = endpoints.oneOnOneRevamped.deleteAiGeneratedValue(masterId);
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      instanceId,
      aiGeneratedDataId,
    },
  });
};
